import useNotificationRequest from './useNotificationRequest'
import { LOCATION_STATES } from 'utils/constants'
import { useHistory } from 'react-router-dom'

const useNotificationAction = () => {
  const { remove, read } = useNotificationRequest()
  const { push } = useHistory()

  const performAction = (id: string, action?: chat.NotificationAction, read_date?: string) => {
    if (!action) {
      if (!read_date) read(id)
      return
    }

    switch (action.type) {
      case 'redirect':
        if (!read_date) read(id)
        push(action.path)
        break

      case 'modal':
        if (!read_date) read(id)
        push(window.location.pathname, LOCATION_STATES.popup({ type: 'notificationModal', props: action }))
        break

      case 'sendPhoto':
        push(window.location.pathname, LOCATION_STATES.popup({ type: action.type, props: action }))
        break
    }
  }

  return {
    read,
    remove,
    performAction
  }
}

export default useNotificationAction